module.exports = __webpack_public_path__ + "img/xGrande.8a49dedc.svg";